<template>
  <div class="">
    <div class="app-content main-width">
      <div class="policy">
        <div id="wrap">
          <h2 class="h2">{{ toolName }}</h2>
          <div class="header_box">
            <span class="span_btn">政策依据</span>
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                {{ policyToolsPolicyFirst
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    @click.native="toPolicyToolsPolicyDetail(item.id)"
                    v-for="(item, index) in policyToolsList"
                    :key="'policy' + index"
                    >{{ item.title }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <div @click="centerDialogFn()" class="zice_btn">
              <span
                >立即自测 <i class="iconfont icon-arrow-right-copy-copy"></i
              ></span>
            </div>
          </div>
          <div class="title_box">
            <span class="backg">!</span>
            <span>带*的信息尤为重要,严重影响自测结果,请您务必填写!</span>
          </div>
          <div class="answer">
            <div
              class="item_box"
              v-for="(item, index) in questionArrList"
              :key="'question' + index"
            >
              <div class="topic">
                <span class="color">*</span>
                <span>{{ index + 1 }}、</span>
                <span
                  v-for="(jtem, jndex) in item.questionName"
                  :key="'name' + jndex"
                >
                  <span v-if="!jtem.keywordExplain">{{ jtem.name }}</span>
                  <el-tooltip
                    class="item"
                    effect="light"
                    placement="bottom-start"
                    v-if="jtem.keywordExplain"
                  >
                    <template #content>
                      <div class="tip_title">百科</div>
                      <div class="tip_content">
                        {{ jtem.keywordExplain }}
                      </div>
                    </template>
                    <span class="keyword"> {{ jtem.name }} </span></el-tooltip
                  >
                </span>
              </div>

              <div class="item" v-if="item.type === 'INPUT'">
                <el-input
                  placeholder="请输入数字"
                  style="width: 150px"
                  v-model="questionForm['value' + item.id]"
                  @input="blurInputValue(questionForm['value' + item.id], item)"
                ></el-input
                ><span>（输入数字）</span>
              </div>
              <div class="item" v-if="item.type === 'RADIO'">
                <el-radio
                  v-for="ktem in item.questionItems"
                  :key="ktem.id"
                  :label="ktem.id"
                  border
                  v-model="questionForm['value' + item.id]"
                  @change="changeRadio(ktem.score, item)"
                  >{{ ktem.name }}</el-radio
                >
              </div>
              <div class="item" v-if="item.type === 'CHECKBOX'">
                <el-checkbox-group
                  v-model="questionForm['value' + item.id]"
                  @change="
                    changeCheckbox(questionForm['value' + item.id], item)
                  "
                >
                  <el-checkbox
                    v-for="ltem in item.questionItems"
                    :label="ltem.id"
                    :key="ltem.id"
                  >
                    {{ ltem.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div
                class="title"
                style="color: #4988df"
                v-show="item.errorFlag === 'right'"
              >
                注：符合
              </div>
              <div
                class="title"
                style="color: red"
                v-show="item.errorFlag === 'error'"
              >
                注：{{ item.errorTips }}
              </div>
            </div>
          </div>
          <div class="flex flex-center">
            <div @click="centerDialogFn()" class="zice_btn">
              <span
                >立即自测 <i class="iconfont icon-arrow-right-copy-copy"></i
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      custom-class="dialog"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="26%"
      center
      @close="dialogType = 0"
    >
      <template v-if="dialogType === 1">
        <div class="text_box">
          根据您的数据，您的匹配度为:
          <h2 class="title" style="display: inline" id="status">
            {{ status }}
          </h2>
        </div>
        <br />
        <div class="flex flex-center">
          <img src="@images/icon/res.png" alt="" />
        </div>
        <h2 class="title" style="text-align: center" id="msg1">{{ msg1 }}</h2>
        <div
          id="msg2"
          class="subtitle pointer wrap"
          style="
            text-align: center;
            margin-top: 15px;
            line-height: normal;
            white-space: pre-wrap !important;
          "
          @click="toService"
        >
          {{ msg2 }}
          <!-- <span style="color: blue">点击咨询</span> -->
        </div>
        <br />
        <div style="font-size: 12px">
          <span style="color: red">温馨提示:</span>
          <span style="color: darkgray; line-height: 15px"
            >政策自测结果仅供参考，请申报单位参考当地申报通知进行申报</span
          >
        </div>
      </template>
      <template v-else>
        <div class="flex flex-center zice_gif">
          <img src="@images/icon/zice.gif" />
        </div>
      </template>
      <template #footer>
        <template v-if="dialogType === 0"></template>
        <template v-else>
          <span class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false"
              >确认</el-button
            >
          </span>
        </template>
      </template>
    </el-dialog>
  </div>
</template>

<script>
// import axios from 'axios';
// import { $ } from "jquery";
import {
  getPolicyToolsQuestion,
  getPolicyToolsPolicyList,
  getSelfTestScore,
} from "@/api/policyTools";
// import AppPage from "@/components/semantics/AppPage.vue";
export default {
  components: {},
  data() {
    return {
      msg1: "",
      msg2: "",
      accordScore: 145,
      status: "",
      dialogVisible: false,
      dialogType: 0,
      dialogTitle: "",
      info: "",
      time: "",
      toolName: this.$route.query.name ? this.$route.query.name : "",
      questionArrList: [],
      questionForm: {},
      policyToolsList: [],
      policyToolsPolicyFirst: "",
    };
  },
  /*watch:{
    $route(to,from){
      console.log(to,from,99999)
      window.location.reload()

    }
  },*/
  created() {
    this.getPolicyToolsList();
    this.getQuestionAllList();
  },
  methods: {
    getPolicyToolsList() {
      getPolicyToolsPolicyList({
        policyToolsId: this.$route.query.policyId,
      }).then((res) => {
        if (res.data.success) {
          this.policyToolsList = res.data.result;
          this.policyToolsPolicyFirst =
            res.data.result.length && res.data.result.length > 0
              ? res.data.result[0].title
              : "";
        } else {
          this.$message.warning(res.data.message);
        }
      });
    },
    getQuestionAllList() {
      getPolicyToolsQuestion({
        policyToolsId: this.$route.query.policyId,
      }).then((res) => {
        if (res.data.success) {
          let questionArr = res.data.result;
          questionArr.map((item) => {
            if (item.type === "CHECKBOX") {
              this.$set(this.questionForm, "value" + item.id, []);
            } else {
              this.$set(this.questionForm, "value" + item.id, "");
            }

            let newArr = [];
            if (item.questionKeywords) {
              newArr = this.getQuestionNameArr(
                item.questionKeywords,
                item.name
              );
            } else {
              newArr.push({ name: item.name });
            }
            item.errorFlag = "";
            item.questionName = newArr;
          });
          this.questionArrList = questionArr;
        } else {
          this.$message.warning(res.data.message);
        }
      });
    },
    getQuestionNameArr(arr, str) {
      let str0 = str,
        arr0 = [];
      arr.map((item) => {
        if (str0.includes(item.keyword)) {
          str0 = str0.replace(
            item.keyword,
            "&%" + item.keyword + "$#" + item.keywordExplain + "&%"
          );
        }
      });
      let arr1 = str0.split("&%");
      arr1.map((jtem) => {
        if (jtem.includes("$#")) {
          let newArr = jtem.split("$#");
          arr0.push({ name: newArr[0], keywordExplain: newArr[1] });
        } else {
          arr0.push({ name: jtem });
        }
      });
      return arr0;
    },
    blurInputValue(value, obj) {
      let inputValue = [value];
      let getScore = this.questionScore(obj, inputValue);
      if (getScore <= 0) {
        obj.errorFlag = "error";
      } else {
        obj.errorFlag = "right";
      }
    },
    changeRadio(scoreValue, obj) {
      if (scoreValue <= 0) {
        obj.errorFlag = "error";
      } else {
        obj.errorFlag = "right";
      }
    },
    changeCheckbox(value, obj) {
      let optionList = obj.questionItems,
        scoreTotal = 0;
      value.map((item) => {
        let index = optionList.findIndex((jtem) => jtem.id === item);
        scoreTotal += optionList[index].score;
      });
      if (scoreTotal <= 0) {
        obj.errorFlag = "error";
      } else {
        obj.errorFlag = "right";
      }
    },
    toPolicyToolsPolicyDetail(id) {
      console.log(id, 88888);
      // this.$router.push("/pcm/GHpolicy_a");
      this.$router.push({
        path: "/pcm/GHpolicy_a",
        query: {
          policyId: id,
        },
      });
    },
    /**
     * 计算单题得分
     * @param question 问题信息
     * @param values 答案
     * @returns {number}
     */
    questionScore(question, values) {
      let score = 0;
      if (values == null || values.length == 0) {
        return score;
      }
      let isSum = false;
      if ("CHECKBOX" == question.type) {
        isSum = true;
      }

      for (let valuesKey in values) {
        let value = values[valuesKey];
        let questionItems = question.questionItems;
        for (let questionItemsKey in questionItems) {
          let item = questionItems[questionItemsKey];
          let calculateRules = JSON.parse(item.calculateRule);
          let result = this.matching(value, calculateRules);
          if (result) {
            score += item.score;
            break;
          }
        }
        if (!isSum) {
          break;
        }
      }

      if (score > question.score) {
        score = question.score;
      }
      return score;
    },

    //规则匹配
    matching(value, calculateRules) {
      let expressionStr = this.getExpressionStr(calculateRules);
      if (expressionStr != null) {
        try {
          console.log();
          if (typeof value == "string") {
            value = "'" + value + "'";
          }
          let expression = expressionStr.replaceAll("N", value);
          let result = eval(expression);
          console.log("N:", value, "公式:", expression, "结果:", result);
          if (result != null) {
            return result;
          }
        } catch (e) {
          console.log("计算异常", e);
        }
      }
      return false;
    },
    //构建公式
    getExpressionStr(calculateRules) {
      if (calculateRules != null && calculateRules.length > 0) {
        let expression = "";
        calculateRules.forEach(function (rule) {
          let operator =
            "=" == rule.operator || "eq" == rule.operator
              ? "=="
              : rule.operator;
          let value =
            "eq" == rule.operator ? "'" + rule.value + "'" : rule.value;
          expression = expression + ("N" + operator + value + "&&");
        });
        return expression.substring(0, expression.length - 2);
      }
      return null;
    },

    toService() {
      /* this.$router.push({
        path: "/detail/market",
        query: {
          goodId: "95c947e2d9514ddfabe3b0dec0ea6f4f",
        },
      }); */
    },
    //获取所有问题总分---最高分
    getTotalScore() {
      let getScoreValue = 0;
      this.questionArrList.map((item) => {
        if (item.type === "CHECKBOX") {
          let scoreValue = 0;
          item.questionItems.map((jtem) => {
            scoreValue += jtem.score;
          });
          getScoreValue += scoreValue;
        } else {
          let scoreValue = item.questionItems.sort((a, b) => {
            return b.score - a.score;
          })[0].score;
          getScoreValue += scoreValue;
        }
      });
      return getScoreValue;
    },
    //获取当前自测的分值
    getSelfTestTotalScore() {
      let testTotalScore = 0;
      Object.keys(this.questionForm).forEach((key) => {
        let getId = key.substr(5);
        let getIndex = this.questionArrList.findIndex(
          (item) => item.id === getId
        );
        if (this.questionForm[key] instanceof Array) {
          let getScore = this.questionScore(
            this.questionArrList[getIndex],
            this.questionForm[key]
          );
          testTotalScore += getScore;
        } else {
          let getScore = this.questionScore(this.questionArrList[getIndex], [
            this.questionForm[key],
          ]);
          testTotalScore += getScore;
        }
      });
      return testTotalScore;
    },
    // 获取当前答案集合
    getAnswerList() {
      let arr = [];
      Object.keys(this.questionForm).forEach((key) => {
        let getId = key.substr(5),
          getValue = [];
        if (this.questionForm[key] instanceof Array) {
          getValue = this.questionForm[key];
        } else {
          getValue.push(this.questionForm[key]);
        }
        let obj = {
          policyToolsQuestionId: getId,
          value: getValue,
        };
        arr.push(obj);
      });
      return arr;
    },
    // 自测弹出框
    centerDialogFn() {
      let notFill = 0;
      Object.keys(this.questionForm).forEach((key) => {
        if (this.questionForm[key] instanceof Array) {
          if (this.questionForm[key].length === 0) {
            notFill++;
          }
        } else {
          if (this.questionForm[key] === "") {
            notFill++;
          }
        }
      });
      if (notFill > 0) {
        this.$message.error("请将带*的题目填写完成");
      } else {
        /*let totalScore = this.getTotalScore()
				let getTestScore = this.getSelfTestTotalScore()*/
        getSelfTestScore({
          policyToolsId: this.$route.query.policyId,
          answers: this.getAnswerList(),
        }).then((res) => {
          if (res.data.success) {
            this.getTestResult(res.data.result);
          } else {
            this.$message.warning(res.data.message);
          }
        });
      }
    },
    getTestResult(val) {
      if (val >= 60 && val <= 80) {
        this.status = "中";
        this.msg1 = "哎呀,差一点!";
        this.msg2 = "您的自测值为中等，申报有风险";
      } else if (val > 80) {
        this.status = "高";
        this.msg1 = "太棒了，恭喜您!";
        this.msg2 = "根据评测结果，建议申报";
      } else if (val < 60) {
        this.status = "低";
        this.msg1 = "再接再厉!";
        this.msg2 = "您的自测分值较低，未达到申报基本条件";
      }
      this.dialogTitle = "计算中";
      this.dialogVisible = true;
      this.dialogType = 0;
      this.time = setTimeout(this.timer, 3000);
    },
    timer: function () {
      this.dialogTitle = "自测结果";
      this.dialogType = 1;
    },

    GHpolicy_a: function () {
      this.$router.push("/pcm/GHpolicy_a");
    },
    GHpolicy_b: function () {
      this.$router.push("/pcm/GHpolicy_b");
    },
  },
};
</script>

<style lang="scss" scoped>
.app-img {
  position: relative;
  height: 220px;
  line-height: 220px;
  padding-left: 60px;
  width: 100%;
  background-image: url("~@/assets/images/bg/apply.png");
  background-size: 100% 100%;
}
.app-title {
  color: $white;
  margin-bottom: 30px;
  font-size: 36px;
}
.app-content {
  box-sizing: border-box;
  background: $white;
  z-index: 999;
  padding: 20px 100px 30px;
  // margin-bottom: 30px;
}
</style>

<style scoped>
.h2 {
  color: #4988df;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}
.header_box {
  padding-bottom: 20px;
  border-bottom: 2px solid #4988df;
}
.span_btn {
  padding: 5px;
  border: 1px solid #4988df;
  color: #4988df;
  margin-right: 10px;
}
.zice_btn {
  color: #fff;
  background: #4988df;
  padding: 8px 22px;
  border-radius: 3px;
  float: right;
  cursor: pointer;
}
.title_box {
  margin-top: 15px;
  padding: 10px;
  border: 1px solid #f8cf96;
  background: #fff9ec;
}
.title_box .backg {
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  color: #fff;
  margin-right: 10px;
  background: #efc28a;
}
.answer {
  padding: 18px;
  font-size: 15px;
}
.answer .color {
  color: #d16963;
}
.answer .item {
  margin-left: 30px;
  /* margin-top: 15px; */
}
.answer .el-radio,
.answer .el-input,
.answer .el-checkbox {
  margin-top: 15px;
}
.answer .item_box {
  padding: 20px 0;
  border-bottom: 1px solid #dbdbdb;
}
.answer .el-button {
  margin-bottom: 10px;
}
.active {
  background-color: #d16963;
  color: #fff;
}
.title {
  margin: 15px 0 0 30px;
  color: #c40311;
}
.tip_title {
  color: #4988df;
  font-weight: bold;
}
.tip_content {
  font-size: 15px;
}
.keyword {
  margin-left: 5px !important;
  color: #4988df;
}

.el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0 !important;
}
/deep/.el-dialog__header {
  background: #4988df;
  padding: 20px 20px 10px;
}
/deep/.el-dialog__title {
  color: #fff;
}

/deep/.el-dialog__headerbtn .el-dialog__close {
  color: black;
}
</style>
